import { Close16 } from '@cian/ui-kit/icons';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './Gallery.css';

interface IGalleryProps {
  imageUrl: string;
  imageAlt: string;
  onClose(): void;
}

export const Gallery: React.FC<IGalleryProps> = ({ imageUrl, imageAlt, onClose }) => {
  return (
    <ModalFullscreen open onClose={onClose} theme="black">
      <div className={styles['container']}>
        <button className={styles['close']} aria-label="Закрыть галерею" onClick={onClose}>
          <Close16 color="white_100" />
        </button>
        <img className={styles['image']} src={imageUrl} alt={imageAlt} />
      </div>
    </ModalFullscreen>
  );
};

Gallery.displayName = 'Gallery';
